import { translate } from '@front/i18n';

const t = translate('screens.signup');

type GetScreenTitleArgs = {
  variantForTitle?: string;
  isChildcareRecurring: boolean;
};

export const getScreenTitle = ({ variantForTitle, isChildcareRecurring }: GetScreenTitleArgs) => {
  if (isChildcareRecurring) {
    return t('.titles.childcare');
  }
  if (variantForTitle === 'treatment1') {
    return t('.titles.booking_tunnel_treatment1');
  }
  if (variantForTitle === 'treatment2') {
    return t('.titles.booking_tunnel_treatment2');
  }
  return t('.titles.booking_tunnel');
};
